
import { Component, Vue } from 'vue-property-decorator'

export type ReserveQuestionMarkerData = {
  resultQuestionId: number
  userAnswerText: string
  correct: number | string
  correctText: string
  score: number | string
}

export type ReserveQuestionMarkerQuery = {
  questionMarkerAssignmentId: number
  questionId: number
}

export type SaveManualScoreParam = {
  questionMarkerAssignmentId: number
  resultQuestions: {
    id: number
    correctText: string
    correct: number
    score: number | null
  }[]
}

@Component
export default class ReserveQuestionMarkerListApis extends Vue {
  /**
   * 採点対象の設問一覧取得
   */
  protected async searchReserveQuestionMarkers(
    reserveQuestionMarkerQuery: ReserveQuestionMarkerQuery
  ): Promise<ReserveQuestionMarkerData[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get('/v1/marker/reserve_question_markers', {
      params: reserveQuestionMarkerQuery,
    })
    return data
  }

  /**
   * 手動採点の保存
   */
  protected async saveManualScore(saveManualScoreParam: SaveManualScoreParam): Promise<void> {
    await Vue.prototype.$http.httpWithToken.put(`/v1/marker/reserve_question_markers/save_manual_score`, {
      questionMarkerAssignmentId: saveManualScoreParam.questionMarkerAssignmentId,
      resultQuestions: saveManualScoreParam.resultQuestions,
    })
  }
}
